import React from 'react';
import * as _ from 'lodash';
import Moment from 'moment';

import CommonModal from './common/Modal';

import { messageUtility } from '../../utilities/messageUtility';

const CsvConditionDialog = props => {
  const { data, visible, onClose } = props;

  const listMarkup =
    !_.isEmpty(data.company_branches) && !_.isEmpty(data.fields)
      ? _.map(data.fields, field => (
          <li className='csv-condition-dialog__item' key={field.id}>
            <span className='csv-condition-dialog__branch'>
              {field.company_branch_name}
            </span>
            <span className='csv-condition-dialog__field'>{field.name}</span>
          </li>
        ))
      : !_.isEmpty(data.company_branches) && _.isEmpty(data.fields)
      ? _.map(data.company_branches, branch => (
          <li className='csv-condition-dialog__item' key={branch.id}>
            <span className='csv-condition-dialog__branch'>{branch.name}</span>
          </li>
        ))
      : _.isEmpty(data.company_branches) && !_.isEmpty(data.fields)
      ? _.map(data.fields, field => (
          <li className='csv-condition-dialog__item' key={field.id}>
            <span className='csv-condition-dialog__branch'>
              {field.company_branch_name}
            </span>
            <span className='csv-condition-dialog__field'>{field.name}</span>
          </li>
        ))
      : _.isEmpty(data.company_branches) &&
        _.isEmpty(data.fields) && <p>すべての支店</p>;

  return (
    <React.Fragment>
      {visible && (
        <CommonModal visible={visible}>
          <div className='dialog-md wide-dialog-md dialog--modal'>
            <div className='dialog-md__header'>
              <span className='dialog-md__title'>データ抽出条件</span>
            </div>
            <div className='dialog-md__body text-center'>
              <div className='csv-condition-dialog__table'>
                <div className='csv-condition-dialog__table-row'>
                  <div className='csv-condition-dialog__table-label'>
                    <p>対象情報</p>
                  </div>
                  <div className='csv-condition-dialog__table-content'>
                    <p>{data.csv_type}</p>
                  </div>
                </div>
                <div className='csv-condition-dialog__table-row'>
                  <div className='csv-condition-dialog__table-label'>期間</div>
                  <div className='csv-condition-dialog__table-content'>
                    <p>
                      {Moment(data.from_date).format('YYYY/MM/DD')}　〜　
                      {Moment(data.to_date).format('YYYY/MM/DD')}
                    </p>
                  </div>
                </div>
                <div className='csv-condition-dialog__table-row'>
                  <div className='csv-condition-dialog__table-label csv-condition-dialog__table-label--align-top'>
                    <p>支店及び現場</p>
                  </div>
                  <div className='csv-condition-dialog__table-content'>
                    <ul className='csv-condition-dialog__list'>{listMarkup}</ul>
                  </div>
                </div>
              </div>
            </div>
            <div className='dialog-md__footer-horizontal'>
              <button className='btn--sub' onClick={onClose}>
                {messageUtility.getMessage('I-000-017')}
              </button>
            </div>
          </div>
        </CommonModal>
      )}
    </React.Fragment>
  );
};

export default CsvConditionDialog;



// WEBPACK FOOTER //
// ./src/components/modals/CsvConditionDialog.jsx